import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=be61d33e&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=be61d33e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be61d33e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be61d33e')) {
      api.createRecord('be61d33e', component.options)
    } else {
      api.reload('be61d33e', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=be61d33e&scoped=true&", function () {
      api.rerender('be61d33e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PMEZMel14lp5/JS/comp/SearchFilterTokens.vue"
export default component.exports